import React from 'react';
import { LegalDocumentPage } from '@/components/LegalDocumentPage';

const PrivacyPolicies: React.FC = () => (
  <LegalDocumentPage documentType="privacy-policy" titleKey="privacy_policy.title" />
);

export default PrivacyPolicies;
